<template>
<div>
    <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>

    <v-row no-gutters class="pa-0" v-if="!raz2">
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz2Items"
          v-model="raz2Selected"
          label="Odaberite razinu 2"
          single-line
          item-text="klasusRaz2"
          item-value="Razina2"
          return-object
          persistent-hint
          clearable
          dense
          outlined
          disabled
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters class="pa-0" v-if="raz2">
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz2Items"
          v-model="raz2Selected"
          label="Odaberite razinu 2"
          single-line
          item-text="klasusRaz2"
          item-value="Razina2"
          return-object
          persistent-hint
          clearable
          dense
          outlined
        ></v-autocomplete>
      </v-col>
    </v-row>
    <KlasusLevel3 :raz1Selected="raz1Selected" :raz2Selected="raz2Selected" />
</div>
</template>

<script>


import KlasusService from '@/services/KlasusService'
import KlasusLevel3 from './KlasusLevel3.vue'
export default {
  name: 'klasusindex',
  props:['raz1Selected'],
  data () {
    return {
      msg: '',
      saving: false,
      raz2: false,
      raz2Items: [],
      raz2Selected: {},
      razUpit: {}
    }
  },
  async mounted () {
    await this.findRaz2()
  },
  methods: {
    async findRaz2() {
      let trazi = false
      if (Object.keys(this.raz1Selected).length > 0) {
        this.razUpit.Razina1 = this.raz1Selected.Razina1
        this.razUpit.onLevel = 2
        trazi = true
      }
      if (trazi) {
        console.log('Trazim na razini 2')
        // (this.raz1Selected ? console.log('Nesto razina 1', this.raz1Selected) : '')
        // console.log('trazim klasus razina2  ', this.razUpit, 'imam promjenu raz1Selected', this.raz1Selected)
        // console.log('trazim klasus razina2  ', this.razUpit, 'imam promjenu raz2Selected', this.raz2Selected)
        await KlasusService.choose(this.razUpit).then(res => {
          if (res.data.klasusData) {
            this.raz2Items = res.data.klasusData
            this.raz2 = true
            console.log('this.raz2Items', this.raz2Items)
          }
        })
        .catch(err => {
          this.havealert = !this.havealert
          this.havemssgalert = 'Error on init Groups ' + err
        })
      }
    }

  },
  computed: {

  },
  watch: {
    'raz1Selected' () {
      if (this.raz1Selected) {
        this.findRaz2()
      }
      if (!this.raz1Selected) {
        console.log('sad ga nemam razina 2')
        this.raz2 = false
      }
    }
  },
  components: {
    KlasusLevel3
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
